import { render, staticRenderFns } from "./User-grade-apply.vue?vue&type=template&id=8dcca83c&scoped=true&"
import script from "./User-grade-apply.vue?vue&type=script&lang=js&"
export * from "./User-grade-apply.vue?vue&type=script&lang=js&"
import style0 from "./User-grade-apply.vue?vue&type=style&index=0&id=8dcca83c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dcca83c",
  null
  
)

export default component.exports